import Chance from 'chance';
const chance = new Chance();
export const getFakeSignature = () => {
    return chance.signature();
};
